import PluginAction from '../plugin-action';

/**
 * Basic control view for managing offers. Can be used as a base for control views of specific offers.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default abstract class AbstractControlAction extends PluginAction {
    /**
     * Form containing all filter options.
     */
    protected filterForm: HTMLFormElement;

    protected constructor(container: HTMLElement) {
        super(container);
        const filterForm = container.querySelector<HTMLFormElement>('#offer-control-filter');
        if (!filterForm) {
            throw new Error('Required elements missing.');
        }
        this.filterForm = filterForm;

        this.initializeFilter();
    }

    /**
     * Initializes the filter for searching for offers.
     */
    private initializeFilter(): void {
        if (!this.filterForm) {
            return;
        }

        const waitingForApprovalCheckbox = this.filterForm.querySelector<HTMLInputElement>('#filter\\[waitingForApproval\\]');
        const approvedCheckbox = this.filterForm.querySelector<HTMLInputElement>('#filter\\[approved\\]');
        const rejectedCheckbox = this.filterForm.querySelector<HTMLInputElement>('#filter\\[rejected\\]');

        waitingForApprovalCheckbox?.addEventListener('change', () => {
            approvedCheckbox!.checked = false;
            rejectedCheckbox!.checked = false;
            this.filterForm.submit();
        });

        approvedCheckbox?.addEventListener('change', () => {
            waitingForApprovalCheckbox!.checked = false;
            rejectedCheckbox!.checked = false;
            this.filterForm.submit();
        });

        rejectedCheckbox?.addEventListener('change', () => {
            waitingForApprovalCheckbox!.checked = false;
            approvedCheckbox!.checked = false;
            this.filterForm.submit();
        });
    }
}
